// Left Swipes table component for DealerDashboard
import React from 'react';
import { Card, Button, Badge, Table, Pagination, Typography } from 'antd';
import { ArrowLeftOutlined, DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

const LeftSwipesTable = ({ 
  filteredLeftData, 
  totalLeftCount,
  currentPage,
  pageSize,
  onPageChange,
  leftSwipesColumns, 
  onTouchStart, 
  onTouchMove, 
  onTouchEnd, 
  onMouseDown,
  onMouseMove,
  onMouseUp,
  swipeIndicatorActive,
  handleExport, 
  setActiveTab 
}) => {
  return (
    <div className="left-swipes-dashboard">
      {/* Header */}
      <div className="page-header">
        <div className="header-left">
          <Button 
            icon={<ArrowLeftOutlined />} 
            type="link" 
            onClick={() => setActiveTab('overview')}
          >
            Back to Dashboard
          </Button>
        </div>
        <div className="header-right">
          <Badge count={totalLeftCount} style={{ backgroundColor: '#ff4d4f' }}>
            <Button 
              icon={<DownloadOutlined />} 
              size="large"
              onClick={handleExport}
              type="primary"
              ghost
            >
              Export
            </Button>
          </Badge>
        </div>
      </div>

      {/* Table */}
      <Card 
        className={`table-card ${swipeIndicatorActive ? 'swipe-indicator' : ''}`}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
      >
        <Table
          columns={leftSwipesColumns}
          dataSource={filteredLeftData}
          pagination={false}
          className="left-swipes-table"
        />
      </Card>

      {/* Pagination */}
      <div className="pagination-container">
        <Text type="secondary">
          {`Showing ${totalLeftCount === 0 ? 0 : (currentPage - 1) * pageSize + 1} to ${Math.min(currentPage * pageSize, totalLeftCount)} from `}
          <span style={{ color: '#ff4d4f', fontWeight: 700, background: '#fff1f0', padding: '0 6px', borderRadius: '10px' }}>{totalLeftCount}</span>
          {` results`}
        </Text>
        <Pagination
          current={currentPage}
          total={totalLeftCount}
          pageSize={pageSize}
          showSizeChanger
          pageSizeOptions={["10","20","50"]}
          onChange={onPageChange}
          className="pagination"
        />
      </div>
    </div>
  );
};

export default LeftSwipesTable;
